import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/success.svg";
var SuccessSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  SuccessSolid_default as default
};
